import {
  GRID_STATE_URL
} from 'app/utils/Constants';

import {
  get,
  put,
  destroy
} from 'app/services/ApiService';

export const getGridState = async (accountId, resource) => {
  return await get(GRID_STATE_URL(accountId, resource));
}

export const setGridState = async (accountId, resource, params) => {
  return await put(GRID_STATE_URL(accountId, resource), params);
}

export const resetGridState = async (accountId, resource) => {
  return await destroy(GRID_STATE_URL(accountId, resource));
}
